export default __webpack_public_path__ + "static/SEO-img-GG-aeac51078c62b08381c611fb70c13f79.png";